var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.accountInfo.status !== 'CV')?_c('PromotionProgress',{attrs:{"lots":_vm.accountInfo.lotsTraded,"status":_vm.accountInfo.status}}):_c('PromotionComplete',{attrs:{"accountInfo":_vm.accountInfo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }